export const SAVE_CIC_ALERT_CRITERIA = 'SAVE_CIC_ALERT_CRITERIA';
export const SAVE_CIC_ALERT_SEARCH_CRITERIA = 'SAVE_CIC_ALERT_SEARCH_CRITERIA';
export const SAVE_CIC_ALERT_GRID_CRITERIA = 'SAVE_CIC_ALERT_GRID_CRITERIA';

export function saveCicAlertCriteria(searchCriteria, gridCriteria) {
  return {
    type: SAVE_CIC_ALERT_CRITERIA,
    searchCriteria,
    gridCriteria
  };
}

export function saveCicAlertSearchCriteria(searchCrieria) {
  return {
    type: SAVE_CIC_ALERT_SEARCH_CRITERIA,
    searchCrieria
  };
}

export function saveCicAlertGridCriteria(gridCriteria) {
  return {
    type: SAVE_CIC_ALERT_GRID_CRITERIA,
    gridCriteria
  };
}
